import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ToolTip from "@material-ui/core/Tooltip";
import CallOutNew from "Component/Headers/callOutNew";

import { instance, instanceMultipart } from "Actions/AxiosInstance";
import {
  removeSaveProgress,
  setSaveProgress,
} from "Actions/SaveProgressAction";
import downloadIcon from "Assets/newicons/action/download/outline/download-outline-16px.svg";
import uploadIcon from "Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import editIcon from "Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import loader from "Assets/Gif/loader.gif";
import { withSnackbar } from "notistack";
import React from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import readXlsxFile from "read-excel-file";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import { bindActionCreators } from "redux";
import "./index.scss";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
  table: {
    width: "100%",
  },
  TableCell: {
    padding: "14px 16px 14px 16px",
    borderBottom: "none",
  },
  TableRow: {
    borderRadius: 4,
  },
  customWidth: {
    maxWidth: 300,
    height: "auto",
    maxHeight: "200px !important",
  },
  popOverPaper: {
    width: 140,
    height: 176,
    background: "transparent",
  },
});

const CANDIDATE_ADD_LIMIT = 100;

const CANDIDATE_DOC_TYPE = {
  RESUME: "1",
  COVER_LETTER: "2",
};

const RECRUIT_XLSX_OPTION = {
  SOURCE: 1,
  JOB: 2,
  STAGE: 3,
};

let arrSourceOptions = [];
let arrJobsOptions = [];
let arrPipelineStage = [];

const defaultProperties = {
  sortable: true,
  filter: true,
  width: 170,
};

const getXLSXOptionId = (intOptKey, strOption) => {
  let intKeyId = null;

  if (intOptKey == RECRUIT_XLSX_OPTION.SOURCE) {
    const objSource = arrSourceOptions.find(
      (objSource) => objSource.displayname === strOption,
    );
    if (objSource && objSource.displayvalue) {
      intKeyId = objSource.displayvalue;
    }
  }

  if (intOptKey == RECRUIT_XLSX_OPTION.JOB) {
    const objJob = arrJobsOptions.find(
      (objJob) => objJob.displayname === strOption,
    );
    if (objJob && objJob.displayvalue) {
      intKeyId = objJob.displayvalue;
    }
  }

  if (intOptKey == RECRUIT_XLSX_OPTION.STAGE) {
    const objSource = arrPipelineStage.find(
      (objStage) => objStage.displayname === strOption,
    );
    if (objSource && objSource.displayvalue) {
      intKeyId = objSource.displayvalue;
    }
  }

  return intKeyId;
};

const getCallingCode = (intCallCode) => {
  let strCallCode = "";

  if (intCallCode) {
    strCallCode = `+${JSON.stringify(intCallCode)}`;
  }

  return strCallCode;
};

const isValidDetail = (objCandidateDetail) => {
  let isValid = false;
  if (objCandidateDetail) {
    isValid = true;

    if (!objCandidateDetail.name || objCandidateDetail.name.trim() === "") {
      return false;
    }

    if (
      !objCandidateDetail.emailid ||
      objCandidateDetail.emailid.trim() === ""
    ) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(objCandidateDetail.emailid);
    }

    if (
      !objCandidateDetail.callingcode ||
      objCandidateDetail.callingcode.trim() === ""
    ) {
      return false;
    }

    if (
      !objCandidateDetail.primarymobile ||
      objCandidateDetail.primarymobile.trim() === ""
    ) {
      return false;
    }

    if (
      !objCandidateDetail.location ||
      objCandidateDetail.location.trim() === ""
    ) {
      return false;
    }

    if (!objCandidateDetail.job || objCandidateDetail.job.trim() === "") {
      return false;
    }

    if (
      !objCandidateDetail.advanceskill ||
      objCandidateDetail.advanceskill.trim() === ""
    ) {
      return false;
    }

    if (
      !objCandidateDetail.elementryskill ||
      objCandidateDetail.elementryskill.trim() === ""
    ) {
      return false;
    }

    if (!objCandidateDetail.expectedsalary) {
      return (
        !isNaN(objCandidateDetail.expectedsalary) &&
        parseInt(Number(objCandidateDetail.expectedsalary)) ==
          objCandidateDetail.expectedsalary &&
        isNaN(parseInt(objCandidateDetail.expectedsalary, 10))
      );
    }

    if (!objCandidateDetail.noticeperiod) {
      return (
        !isNaN(objCandidateDetail.noticeperiod) &&
        parseInt(Number(objCandidateDetail.noticeperiod)) ==
          objCandidateDetail.noticeperiod &&
        isNaN(parseInt(objCandidateDetail.noticeperiod, 10))
      );
    }
  }
  return isValid;
};

class UploadDoc extends React.Component {
  componentWillReceiveProps(nextProps) {
    this.setState({ props: nextProps });
  }

  upload = (e) => {
    this.props.context.componentParent.uploadSingleCandidateDoc(
      e,
      this.props.rowIndex,
      this.props.intFileTypeId,
    );
  };

  render() {
    const arrCandidateDetails_From_Parent =
      this.props.context.componentParent.state.arrCandidateDetails || [];
    return (
      <Dropzone
        onDrop={(e) => this.upload(e)}
        multiple={false}
        accept=".pdf,.doc,.docx"
        maxSize={2000000}
        className="width80 height100 drag-drop"
      >
        {
          /**
           * @param {IntFileTypeId} DOC Type - if 1 then Resume, if 2 then Cover Letter
           * Check if resume is uploaded then resume name will be shown
           */
          this.props.intFileTypeId == 1 &&
          arrCandidateDetails_From_Parent[this.props.rowIndex] &&
          arrCandidateDetails_From_Parent[this.props.rowIndex]
            .resumefilename ? (
            <div className="vertical-center">
              {
                arrCandidateDetails_From_Parent[this.props.rowIndex]
                  .resumefilename
              }
            </div>
          ) : /**
           * @param {IntFileTypeId} DOC Type - if 1 then Resume, if 2 then Cover Letter
           * Check if CV is uploaded then cv name will be shown
           */
          this.props.intFileTypeId == 2 &&
            arrCandidateDetails_From_Parent[this.props.rowIndex] &&
            arrCandidateDetails_From_Parent[this.props.rowIndex]
              .coverletterfilename ? (
            <div className="vertical-center">
              {
                arrCandidateDetails_From_Parent[this.props.rowIndex]
                  .coverletterfilename
              }
            </div>
          ) : (
            /**
             * If no file is uploaded then upload icon will be shown
             */
            <div className="uploader-wrapper cursor-pointer">
              <div className="vertical-center">
                <img src={uploadIcon} className="vertical-middle"></img>
              </div>
            </div>
          )
        }
      </Dropzone>
    );
  }
}

class Uploadapplication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      boolIsLoader: false,
      objContext: {
        componentParent: this,
      },
      objDefaultColDef: {
        resizable: true,
      },
      arrCandidateDetails: [],
      arrPreviewColumns: [
        {
          field: "name",
          headerName: "Candidate Name",
          ...defaultProperties,
        },
        {
          field: "emailid",
          headerName: "Email Id",
          ...defaultProperties,
          cellStyle: (params) => {
            if (params.data.isUniqueError == true) {
              return { border: "1px solid red" };
            } else {
              return { border: "none" };
            }
          },
        },
        {
          field: "callingcode",
          headerName: "Calling Code",
          ...defaultProperties,
        },
        {
          field: "primarymobile",
          headerName: "Phone",
          ...defaultProperties,
          cellStyle: (params) => {
            if (params.data.isUniqueError == true) {
              return { border: "1px solid red" };
            } else {
              return { border: "none" };
            }
          },
        },
        {
          field: "location",
          headerName: "Location",
          ...defaultProperties,
        },
        {
          field: "source",
          headerName: "Source",
          ...defaultProperties,
        },
        {
          field: "job",
          headerName: "Job",
          ...defaultProperties,
        },
        {
          field: "stage",
          headerName: "Stage",
          ...defaultProperties,
        },
        {
          field: "advanceskill",
          headerName: "Advance Skills",
          ...defaultProperties,
        },
        {
          field: "elementryskill",
          headerName: "Elementry Skills",
          ...defaultProperties,
        },
        {
          field: "noticeperiod",
          headerName: "Notice Period",
          ...defaultProperties,
        },
        {
          field: "resumepath",
          headerName: "Resume",
          ...defaultProperties,
          // cellRendererFramework: (params) => (
          //   <UploadDoc {...params} intFileTypeId={1} />
          // ),
        },
        {
          field: "coverletterpath",
          headerName: "Cover Letter",
          ...defaultProperties,
          // cellRendererFramework: (params) => (
          //   <UploadDoc {...params} intFileTypeId={2} />
          // ),
        },
      ],
    };

    this.onGridReady = this.onGridReady.bind(this);
  }

  componentDidMount() {
    this.getXLSXOptions();
  }

  handleClose() {
    const arrCandidateDetails = [...this.state.arrCandidateDetails];
    const arrFileToDelete = [];

    arrCandidateDetails.forEach((objCandidate) => {
      if (objCandidate.resumepath) {
        arrFileToDelete.push(objCandidate.resumepath);
      }
      if (objCandidate.coverletterpath) {
        arrFileToDelete.push(objCandidate.coverletterpath);
      }
    });
  }

  onGridReady(params) {
    this.gridapi = params.api;
  }

  getXLSXOptions() {
    instance
      .get(
        `recruit/xlsxoptions/${
          this.props.carddata
            ? this.props.carddata.displayvalue
            : this.props.tabpipelineid
        }`,
      )
      .then((result) => {
        if (result.data.result && result.data.result.length > 0) {
          arrSourceOptions = result.data.result[0].source;
          arrJobsOptions = result.data.result[0].jobs;
          arrPipelineStage = result.data.result[0].stages;
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  downloadBulkAddXLSXTemplate = async () => {
    instance
      .get(
        `/recruit/getbulkaddcandidatexlsformat/${
          this.props.carddata
            ? this.props.carddata.displayvalue
            : this.props.tabpipelineid
        }`,
        {
          responseType: "blob",
        },
      )
      .then((result) => {
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Application_Template.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
  };

  uploadBulkAddXLSXFile = async (arrUploadedFile = []) => {
    const objUploadXLSXFile = arrUploadedFile[0];

    if (!objUploadXLSXFile) return;

    const strUploadXLSXFileName = objUploadXLSXFile.name;
    const strUploadXLSXFileExtantion = strUploadXLSXFileName
      .substr(
        strUploadXLSXFileName.lastIndexOf(".") + 1,
        strUploadXLSXFileName.length,
      )
      .toLowerCase();

    if (
      strUploadXLSXFileExtantion != "xlsx" &&
      strUploadXLSXFileExtantion != "xls"
    ) {
      this.props.enqueueSnackbar(
        "Please select valid file format (Supported : xlsx and xls)",
        { variant: "error" },
      );
      return;
    }

    const arrXLSXFileContent = await readXlsxFile(objUploadXLSXFile);

    const arrCandidateDetails = arrXLSXFileContent
      .slice(1, arrXLSXFileContent.length)
      .map((x) => ({
        name: x[0],
        emailid: x[1],
        callingcode: getCallingCode(x[2]),
        primarymobile: x[3] ? JSON.stringify(x[3]) : "-",
        location: x[4],
        source: x[5],
        job: x[6],
        stage: x[7],
        advanceskill: x[8],
        elementryskill: x[9],
        noticeperiod: x[10],
        expectedsalary: x[11],
        resumepath: null,
        coverletterpath: null,
      }))
      .filter((objFilledDetails) => isValidDetail(objFilledDetails) && true);
    this.setState({ arrCandidateDetails, strUploadXLSXFileName });
  };

  uploadBulkResumeZipFile = async (
    arrUploadedFile = [],
    intRowIndex,
    intFileTypeId = null,
  ) => {
    const formData = new FormData();
    formData.append("file", arrUploadedFile[0]);

    /**
     * start the zip loader as it take time
     */
    this.setState({ boolIsLoader: true });

    instanceMultipart
      .post(`/recruit/zipfile`, formData)
      .then((resp) => {
        if (resp.data.result && resp.data.result.length > 0) {
          const arrCandidateDocUploadDetail = resp.data.result;
          const arrFileToDelete = arrCandidateDocUploadDetail.map(
            (objDoc) => objDoc.path,
          );

          this.setState(
            {
              arrCandidateDocUploadDetail,
              strUploadedZipFileName: arrUploadedFile[0].name,
              boolIsLoader: false,
            },
            () => this.props.setDeleteFile(arrFileToDelete),
          );
        }
      })
      .catch((error) => {
        this.setState(
          {
            boolIsLoader: false,
          },
          () =>
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            ),
        );
      });
  };

  uploadSingleCandidateDoc(arrFiles, intRowIndex, intFileTypeId) {
    const arrCandidateDetails = [...this.state.arrCandidateDetails];

    const formData = new FormData();
    formData.append("file", arrFiles[0]);

    this.setState({ boolIsLoader: true });

    instanceMultipart
      .post(`/drive/uploaddocument`, formData)
      .then((resp) => {
        if (intFileTypeId == CANDIDATE_DOC_TYPE.RESUME) {
          arrCandidateDetails[intRowIndex].resumepath =
            resp.data.result[0].imagepath;
          arrCandidateDetails[intRowIndex].resumefilename =
            resp.data.result[0].originalname;
        }

        if (intFileTypeId == CANDIDATE_DOC_TYPE.COVER_LETTER) {
          arrCandidateDetails[intRowIndex].coverletterpath =
            resp.data.result[0].imagepath;
          arrCandidateDetails[intRowIndex].coverletterfilename =
            resp.data.result[0].originalname;
        }

        this.setState({ arrCandidateDetails, boolIsLoader: false });
      })
      .catch((error) => {
        this.setState(
          {
            boolIsLoader: false,
          },
          () =>
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            ),
        );
      });
  }

  mapDocToCandidate() {
    /**
     * map resume and cv to candiate to candidate details
     */
    let arrCandidateDetails = [...this.state.arrCandidateDetails];
    const arrCandidateDocUploadDetail = [
      ...this.state.arrCandidateDocUploadDetail,
    ];

    /**
     * Truncate the array of candidate to give limit
     */
    if (arrCandidateDetails.length > CANDIDATE_ADD_LIMIT) {
      arrCandidateDetails = arrCandidateDetails.slice(0, CANDIDATE_ADD_LIMIT);
    }

    arrCandidateDetails = arrCandidateDetails
      .map((objCandidate) => {
        const arrCandidateDoc = arrCandidateDocUploadDetail.filter((objDoc) =>
          objDoc.filename.includes(objCandidate.emailid),
        );

        for (const objCandidateDoc of arrCandidateDoc) {
          if (objCandidateDoc && objCandidateDoc.path) {
            if (CANDIDATE_DOC_TYPE.RESUME == objCandidateDoc.doctypeid) {
              objCandidate.resumepath = objCandidateDoc.path;
              objCandidate.resumefilename = objCandidateDoc.filename;
            }

            if (CANDIDATE_DOC_TYPE.COVER_LETTER == objCandidateDoc.doctypeid) {
              objCandidate.coverletterpath = objCandidateDoc.path;
              objCandidate.coverletterfilename = objCandidateDoc.filename;
            }
          }
        }

        objCandidate.isUniqueError = false;
        return objCandidate;
      })
      .filter((objCandidate) => objCandidate.resumepath && true); // Check if resume exist or not

    this.setState({ arrCandidateDetails });
  }

  bulkAddCandidate() {
    const arrCandidateDetails = [...this.state.arrCandidateDetails];

    arrCandidateDetails.forEach((objCandidateData) => {
      objCandidateData.city = objCandidateData.location;
      objCandidateData.callingcode = objCandidateData.callingcode.replace(
        "+",
        "",
      );
      objCandidateData.mobilenumber = objCandidateData.primarymobile;
      objCandidateData.requisitionjobid = getXLSXOptionId(
        RECRUIT_XLSX_OPTION.JOB,
        objCandidateData.job,
      );
      objCandidateData.sourcetypeid = getXLSXOptionId(
        RECRUIT_XLSX_OPTION.SOURCE,
        objCandidateData.source,
      );
      objCandidateData.pipelinestageid = getXLSXOptionId(
        RECRUIT_XLSX_OPTION.STAGE,
        objCandidateData.stage,
      );
      objCandidateData.profilepicpath = null;
      objCandidateData.candidatecontact = [];
      objCandidateData.candiatequestionfeedback = [];
      objCandidateData.candidateexperience = [];
      objCandidateData.candidateeducation = [];
      delete objCandidateData.isUniqueError;
    });

    instance
      .post("recruit/configcandidateapplicationbulk", {
        candidatedetails: [...arrCandidateDetails],
      })
      .then((result) => {
        const arrCandidateDetails = [...this.state.arrCandidateDetails];
        if (result.data.result && result.data.result.length > 0) {
          const arrCandidateWithError =
            result.data.result[0].candidaterror || [];
          let boolIsError = false;

          arrCandidateWithError.forEach((objCandidate) => {
            const intCandidateIndex = arrCandidateDetails.findIndex(
              (objCandidateDetail) =>
                objCandidateDetail.emailid == objCandidate.emailid &&
                objCandidateDetail.primarymobile == objCandidate.primarymobile,
            );

            if (intCandidateIndex > -1) {
              if (
                objCandidate.errorcode === "E3330" ||
                objCandidate.errorcode === "E3340"
              ) {
                arrCandidateDetails[intCandidateIndex].isUniqueError = true;
                boolIsError = true;
              }
            }
            arrCandidateDetails[intCandidateIndex].error = objCandidate.error;
          });

          if (boolIsError) {
            this.setState({ arrCandidateDetails }, () => {
              this.gridapi.setRowData(arrCandidateDetails);
              this.gridapi.updateRowData({ update: arrCandidateDetails });
              this.props.enqueueSnackbar(
                "Please rectify the issue highlighted in red. Hint: Candidate with same email id or mobile number already exist.",
                { variant: "error" },
              );
            });
          } else {
            this.setState(
              {
                boolIsPreview: false,
                postdata: [],
              },
              () => {
                this.props.enqueueSnackbar("Saved successfully", {
                  variant: "success",
                });
                this.props.CloseDrawer();
                this.props.getData(this.props.carddata);
              },
            );
          }
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  render() {
    return (
      <div>
        <Grid container className="margin-top-16" spacing={3}>
          <Grid item md={12} sm={12} className="position-rel">
            <div style={{ position: "absolute", top: -44 }}>
              <div>
                <div>
                  <p className="normal-dark margin-bottom-16 margin-top-16">
                    Upload multiple applications to this pipeline ⬆️
                  </p>
                </div>
              </div>
              <div>
                <CallOutNew
                  classnames="bg-light-blue"
                  header={
                    <span>
                      Zip file can contain multiple files with resume and cover
                      letter & the file names must follow the below convention:
                      <ul>
                        <li>
                          For resume: emailid.extension (Example:
                          megha.sharma@gmail.com.pdf)
                        </li>
                        <li>
                          For cover letter: emailid_cover.extension (Example:
                          megha.sharma@gmail.com_cover.docx)
                        </li>
                      </ul>
                      Supported extensions are pdf, docx, doc, jpeg! Bulk
                      candidate upload is limited to max 100 candidates.
                    </span>
                  }
                  emoji=""
                  textcolor="#1e8ced"
                />
                <ul
                  className="padding-left-0"
                  style={{ listStyleType: "none" }}
                >
                  <li
                    className="margin-bottom-16 display-flex"
                    style={{
                      textDecoration: this.state.isStepCompleted
                        ? "line-through"
                        : "none",
                    }}
                  >
                    <span className="small-dark-secondary t-bold">Step 1:</span>
                    <div
                      className="display-flex cursor-pointer"
                      onClick={this.downloadBulkAddXLSXTemplate}
                    >
                      <span className="link-small margin-right-8">
                        &nbsp;&nbsp;Download CSV template
                      </span>

                      <img src={downloadIcon}></img>
                    </div>
                  </li>
                  <li
                    className="small-dark-secondary margin-bottom-16 margin-top-16"
                    style={{
                      textDecoration: this.state.isStepCompleted
                        ? "line-through"
                        : "none",
                    }}
                  >
                    <span className="t-bold">Step 2:</span>
                    &nbsp; File application details into the CSV file
                  </li>
                  <li
                    className="small-dark-secondary margin-bottom-16 margin-top-16 display-flex"
                    style={{
                      textDecoration: this.state.isStepCompleted
                        ? "line-through"
                        : "none",
                    }}
                  >
                    <span className="t-bold">Step 3:</span>
                    <div>
                      {this.state.strUploadXLSXFileName ? (
                        <div className="display-flex">
                          <span
                            className="small-dark-secondary margin-right-16 ellipsis"
                            style={{ width: 300 }}
                          >
                            &nbsp;&nbsp;Current Uploaded :-{" "}
                            <ToolTip
                              title={this.state.strUploadXLSXFileName}
                              placement="top"
                            >
                              <strong>
                                {this.state.strUploadXLSXFileName}{" "}
                              </strong>
                            </ToolTip>
                          </span>
                          <div>
                            <Dropzone
                              onDrop={(e) => this.uploadBulkAddXLSXFile(e)}
                              multiple={false}
                              accept=".xlsx, .xls"
                              // maxSize={2000000}
                              className="width80 height100 drag-drop"
                            >
                              <img
                                src={editIcon}
                                style={{ cursor: "pointer" }}
                              />
                            </Dropzone>
                          </div>
                        </div>
                      ) : (
                        <div style={{ width: "250px" }}>
                          <p className="small-dark-secondary margin-bottom-8">
                            &nbsp;&nbsp;Upload the populated CSV file
                          </p>
                          <Dropzone
                            onDrop={(e) => this.uploadBulkAddXLSXFile(e)}
                            multiple={false}
                            accept=".xlsx, .xls"
                            //  maxSize={2000000}
                            className="width80 height100 drag-drop"
                          >
                            <div className="uploader-wrapper cursor-pointer">
                              <div
                                className="vertical-center"
                                style={{ height: 20 }}
                              >
                                <img
                                  src={uploadIcon}
                                  className="vertical-middle"
                                ></img>
                                <span className="margin-left-16 small-blue">
                                  Click here to upload
                                </span>
                              </div>
                            </div>
                          </Dropzone>
                        </div>
                      )}
                    </div>
                  </li>

                  <li
                    className="small-dark-secondary margin-bottom-16 display-flex"
                    style={{
                      textDecoration: this.state.isStepCompleted
                        ? "line-through"
                        : "none",
                    }}
                  >
                    <span className="t-bold">Step 4:</span>
                    {this.state.strUploadedZipFileName ? (
                      <div className="width80">
                        {this.state.boolIsLoader ? (
                          <img className="loader" src={loader} />
                        ) : (
                          <div className="display-flex">
                            <span
                              className="small-dark-secondary margin-right-16 ellipsis"
                              style={{ width: 300 }}
                            >
                              &nbsp;&nbsp;Current Uploaded :-{" "}
                              <ToolTip
                                title={this.state.strUploadedZipFileName}
                                placement="top"
                              >
                                <strong>
                                  {" "}
                                  {this.state.strUploadedZipFileName}{" "}
                                </strong>
                              </ToolTip>
                            </span>
                            <div>
                              <Dropzone
                                onDrop={(e) => this.uploadBulkResumeZipFile(e)}
                                multiple={false}
                                accept=".zip"
                                // maxSize={2000000}
                                className="width80 height100 drag-drop"
                              >
                                <img
                                  src={editIcon}
                                  style={{ cursor: "pointer" }}
                                />
                              </Dropzone>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div style={{ width: "250px" }}>
                        <p className="small-dark-secondary margin-bottom-8">
                          &nbsp; Upload zip with CV PDF{" "}
                        </p>
                        <Dropzone
                          onDrop={(e) => this.uploadBulkResumeZipFile(e)}
                          multiple={false}
                          accept=".zip"
                          // maxSize={2000000}
                          className="width80 height100 drag-drop"
                          disabled={!this.state.strUploadXLSXFileName}
                        >
                          {this.state.boolIsLoader ? (
                            <img className="loader" src={loader} />
                          ) : (
                            <div className="uploader-wrapper cursor-pointer">
                              <div
                                className="vertical-center"
                                style={{ height: 20 }}
                              >
                                <img
                                  src={uploadIcon}
                                  className="vertical-middle"
                                ></img>
                                <span className="margin-left-16 small-blue">
                                  Click here to upload
                                </span>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                      </div>
                    )}
                  </li>
                </ul>

                <Button
                  className="btn btn-primary-md-blue margin-top-32"
                  variant="contained"
                  color="primary"
                  disabled={
                    !(
                      this.state.strUploadXLSXFileName &&
                      this.state.strUploadedZipFileName
                    )
                  }
                  onClick={() =>
                    this.setState(
                      {
                        boolIsPreview: true,
                      },
                      () => this.mapDocToCandidate(),
                    )
                  }
                >
                  Preview
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
        <Dialog
          fullWidth={true}
          maxWidth="lg"
          open={this.state.boolIsPreview}
          onClose={() => this.setState({ boolIsPreview: false })}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>Preview before adding candidates</div>
            </div>
          </DialogTitle>
          <DialogContent>
            <div
              className="ag-theme-balham"
              style={{
                height: "450px",
                width: "100%",
              }}
            >
              <AgGridReact
                className="previewheight"
                context={this.state.objContext}
                columnDefs={this.state.arrPreviewColumns}
                onGridReady={this.onGridReady}
                rowData={this.state.arrCandidateDetails}
                rowDragManaged={true}
                animateRows={true}
                defaultColDef={this.state.objDefaultColDef}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              className="preview-btn"
              size="small"
              variant="contained"
              color="primary"
              disabled={false}
              onClick={() => this.bulkAddCandidate()}
            >
              Save
            </Button>
            <Button
              onClick={() => this.setState({ boolIsPreview: false })}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SaveInProgressReducer: state.SaveInProgressReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  login: state.AuthenticationAction.login,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Uploadapplication)));
